import styled from "styled-components";

export const SingleOrderActionsWrapper = styled.div`
    display: flex;
    gap: 5px;
`;
